// extracted by mini-css-extract-plugin
export var cardHeader = "_t0-0";
export var reorderHandle = "_t0-3";
export var titleArea = "_t0-1";
export var titleAreaWithHandle = "_t0-2";